import { Button, Input, Modal } from "@convergence/components";
import { useEffect, useState } from "react";
import { useAuthContext } from "../components/AuthProvider";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useDeleteMeMutation } from "../api/deleteMe";
import { useErrorToast } from "../hooks/useErrorToast";

export function Delete() {
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const authContext = useAuthContext();
    const navigate = useNavigate();

    const randomStarWarsCharacterQuery = useQuery({
        queryKey: ["delete"],
        queryFn: async () => {
            const response = await fetch("https://random-star-wars-character.vercel.app/api", { method: "GET" });
            const data = await response.text();
            return data;
        },
    });



    const [input, setInput] = useState("");
    const deleteMeMutation = useDeleteMeMutation();
    const handleDelete = async () => {
        try {

            const res = await deleteMeMutation.mutateAsync();
            if (res.success) {
                navigate("/login");
            }
        } catch (err) {
            toast.error("Failed to delete account");
        }
    }


    useEffect(() => {
        if (authContext.isLoading) {
            return;
        }
        if (!authContext.user) {
            navigate("/login");
        }
    }, [authContext]);

    useErrorToast(deleteMeMutation.error);

    if (authContext.isLoading) {
        return <div>Loading...</div>;
    }

    const frown = "(ó﹏ò｡)"

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-white p-4">
            <div className="items-center justify-center border-2 border-black p-4 flex flex-col gap-8">
                <h1 className="text-4xl ">Delete My Account</h1>
                <p>Are you sure you want to delete your account?</p>
                <div className="flex flex-row items-center justify-center gap-4">
                    <Button onClick={() => setShowConfirmModal(true)} className="group relative">
                        <span className="inline-block">Delete My Account</span>
                        <br className="hidden group-hover:inline-block" />
                        <span className="absolute -scale-x-100 translate-y-1/2 -translate-x-full hidden group-hover:inline-block">💦</span>
                        <span className="hidden group-hover:inline-block">{frown}</span>
                        <span className="absolute hidden group-hover:inline-block translate-y-1/2">💦</span>

                    </Button>
                </div>
            </div>
            <Modal visible={showConfirmModal} onClose={() => setShowConfirmModal(false)}>
                <div className="flex flex-col items-center justify-center border-2 border-black h-full w-full text-lg text-center gap-6"  >
                    <p>Are you sure you want to delete your account?<br />
                        Please type the name of the Star Wars character below to confirm:
                    </p>
                    <p className="italic">{randomStarWarsCharacterQuery.data ? randomStarWarsCharacterQuery.data : "Loading..."}</p>
                    <Input type="text" value={input} onChange={(e) => setInput(e.target.value)} />
                    <div className="flex flex-row items-center justify-center">
                        <Button disabled={input !== randomStarWarsCharacterQuery.data} variant="red" onClick={handleDelete}>Delete</Button>
                    </div>
                </div>
            </Modal>
        </div >
    );
}